const AUTOCOMPLETE_ADDRESS_COMPONENTS = {
  subpremise: 'short_name',
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'short_name',
  administrative_area_level_2: 'long_name',
  administrative_area_level_3: 'long_name',
  country: 'long_name',
  postal_code: 'short_name',
  neighborhood: 'long_name',
  sublocality_level_1: 'long_name'

}
const AUTOCOMPLETE_CITIES_TYPE = ['locality', 'administrative_area_level_3']
const AUTOCOMPLETE_REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country',
  'administrative_area_level_1', 'administrative_area_level_2']

const setupGooglePlaces = () => {
  return new Promise(function (resolve, reject) {
    if (typeof google === 'object') {
      resolve('is loaded already')
      return
    }
    let googleSearchElement = [...document.getElementsByTagName('script')].filter(el => el.id === 'googlePlaces')
    var el = googleSearchElement.length ? googleSearchElement[0] : document.createElement('script')
    el.setAttribute('id', 'googlePlaces')
    el.async = true
    el.addEventListener('load', function () {
      resolve('LOADED')
    }, false)
    el.addEventListener('error', function () {
      reject(new Error())
    }, false)
    if (!googleSearchElement.length) {
      el.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_API_KEY}&libraries=places`
      document.getElementsByTagName('head')[0].appendChild(el)
    }
  })
}

export {
  AUTOCOMPLETE_ADDRESS_COMPONENTS,
  AUTOCOMPLETE_CITIES_TYPE,
  AUTOCOMPLETE_REGIONS_TYPE,
  setupGooglePlaces

}
